import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './tokas.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/260210/tokas-le_mclaren26-tortoise--{nnn}.png',
}

export default {
  supports360: false,
  layers: [background, body],
  resolveOptions: () => ({}),
}
